/**
 * @class Oskari.mapframework.bundle.printout.service.PrintService
 * Requests to print preview and for legend parameters
 *
 */
Oskari.clazz.define('Oskari.mapframework.bundle.printout.service.PrintService',
/**
 * @method create called automatically on construction
 * @static
 *
 */

function (instance) {
  this.instance = instance;
  this.sandbox = instance.sandbox;
}, {
  __name: 'Printout.PrintService',
  __qname: 'Oskari.mapframework.bundle.printout.service.PrintService',
  getQName: function getQName() {
    return this.__qname;
  },
  getName: function getName() {
    return this.__name;
  },
  /**
   * @method init
   * Initializes the service
   */
  init: function init() {},
  fetchPrint: function fetchPrint(url, payload, successCb, errorCb) {
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: 'blob',
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (response.ok) {
        return response.blob();
      } else {
        return Promise.reject(new Error('Failed to get print'));
      }
    }).then(function (blob) {
      successCb(blob);
    }).catch(function (error) {
      return errorCb(error);
    });
  }
}, {
  protocol: ['Oskari.mapframework.service.Service']
});